"use strict";
exports.__esModule = true;
exports.GridGutters = exports.Breakpoints = exports.BorderRadii = void 0;
var BorderRadii;
(function (BorderRadii) {
    BorderRadii[BorderRadii["radius4"] = 4] = "radius4";
    BorderRadii[BorderRadii["radius8"] = 8] = "radius8";
    BorderRadii[BorderRadii["radius16"] = 16] = "radius16";
    BorderRadii[BorderRadii["radius20"] = 20] = "radius20";
    BorderRadii[BorderRadii["radius24"] = 24] = "radius24";
})(BorderRadii = exports.BorderRadii || (exports.BorderRadii = {}));
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["XS"] = 576] = "XS";
    Breakpoints[Breakpoints["S"] = 768] = "S";
    Breakpoints[Breakpoints["M"] = 1048] = "M";
    Breakpoints[Breakpoints["L"] = 1200] = "L";
    Breakpoints[Breakpoints["XL"] = 1400] = "XL";
})(Breakpoints = exports.Breakpoints || (exports.Breakpoints = {}));
var GridGutters;
(function (GridGutters) {
    GridGutters[GridGutters["default"] = 16] = "default";
    GridGutters[GridGutters["small"] = 24] = "small";
    GridGutters[GridGutters["medium"] = 32] = "medium";
    GridGutters[GridGutters["large"] = 40] = "large";
})(GridGutters = exports.GridGutters || (exports.GridGutters = {}));
